export default "__VITE_ASSET__DzgV607n__"